// extracted by mini-css-extract-plugin
export default {"root":"athlete-bid_buy_sell-btn_root__E25Sm"};